import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
(function(IDisclaimer) {
    (function(Icon) {
        Icon["ICON_UNKNOWN"] = "ICON_UNKNOWN";
        Icon["INTERNATIONAL"] = "INTERNATIONAL";
        Icon["CAUTION"] = "CAUTION";
        Icon["DOLLAR_SIGN"] = "DOLLAR_SIGN";
        Icon["PERCENT_SIGN"] = "PERCENT_SIGN";
        Icon["SHIPMENT_DELIVERED"] = "SHIPMENT_DELIVERED";
        Icon["STACK_BILL"] = "STACK_BILL";
        Icon["DIAMOND"] = "DIAMOND";
        Icon["CALENDAR"] = "CALENDAR";
        Icon["DOLLAR_SIGN_WITH_CIRCLE_ARROW"] = "DOLLAR_SIGN_WITH_CIRCLE_ARROW";
    })(IDisclaimer.Icon || (IDisclaimer.Icon = {}));
    (function(Type) {
        Type["TYPE_UNKNOWN"] = "TYPE_UNKNOWN";
        Type["INSTRUMENT_BLOCKER"] = "INSTRUMENT_BLOCKER";
        Type["PREPAID_CARD_BLOCKER"] = "PREPAID_CARD_BLOCKER";
        Type["PREPAID_CARD_NET_BLOCKER"] = "PREPAID_CARD_NET_BLOCKER";
        Type["REGION_RESTRICTION"] = "REGION_RESTRICTION";
        Type["FACE_MASK"] = "FACE_MASK";
        Type["INSTRUMENT_MUST_BE_UPDATED"] = "INSTRUMENT_MUST_BE_UPDATED";
        Type["INSIDER"] = "INSIDER";
        Type["ECO_FRIENDLY_OFFSETS"] = "ECO_FRIENDLY_OFFSETS";
        Type["RESELLER_CERTIFICATE_REQUIRED"] = "RESELLER_CERTIFICATE_REQUIRED";
        Type["FAIRE_PAY_UPSELL"] = "FAIRE_PAY_UPSELL";
        Type["FAIRE_PAY_SAVING"] = "FAIRE_PAY_SAVING";
        Type["UNPAID_EXCLUSIVITY_AGREEMENT"] = "UNPAID_EXCLUSIVITY_AGREEMENT";
        Type["LAST_PAYMENT_FAILED_GENERIC"] = "LAST_PAYMENT_FAILED_GENERIC";
        Type["LAST_PAYMENT_FAILED_INSUFFICIENT_FUNDS"] = "LAST_PAYMENT_FAILED_INSUFFICIENT_FUNDS";
        Type["DISCOVERY_TERMS_CHECKOUT"] = "DISCOVERY_TERMS_CHECKOUT";
    })(IDisclaimer.Type || (IDisclaimer.Type = {}));
    IDisclaimer.build = function(partial) {
        return _object_spread({}, partial !== null && partial !== void 0 ? partial : {});
    };
})(IDisclaimer || (IDisclaimer = {}));
export var IDisclaimer;
